// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AdminDownloadAssetRequestModel from '../../model/admin-download-asset-request-model';
import AdminDownloadAssetRequestDTO from '../dto/admin-download-asset-request-dto';
import dtoSchema from '../schemas/admin-download-asset-request-schema';

export default abstract class AdminDownloadAssetRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AdminDownloadAssetRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<AdminDownloadAssetRequestDTO>): AdminDownloadAssetRequestModel;
  static toModel(dto: DeepPartial<AdminDownloadAssetRequestDTO> | undefined | null): AdminDownloadAssetRequestModel | undefined;
  static toModel(dto: DeepPartial<AdminDownloadAssetRequestDTO> | undefined | null): AdminDownloadAssetRequestModel | undefined {
    return dto ? new AdminDownloadAssetRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AdminDownloadAssetRequestModel> | AdminDownloadAssetRequestModel): AdminDownloadAssetRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as AdminDownloadAssetRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AdminDownloadAssetRequestModel, can not map to AdminDownloadAssetRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
